import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Input, Button } from 'antd';
import Icon from 'kts-platform-frame/display/components/Icon';
import { create } from 'kts-scaffold-framework/utils/form';
import { Decorators } from 'kts-scaffold-framework/utils/doc';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    userInfo?: IUserInfo;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    userInfo: state.user.userInfo,
}))
export default class UIInfo extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const changeType = this.modulesState.changContactType;
        enum typeList {
            phone = "手机号",
            email = "邮箱",
        }

        return (
            <div className={css.ModalChangePhoneNum}>
                <div className={css.header}>
                    <div className={css.title}>修改{typeList[changeType]}</div>
                    <div className={css.titleDes}>请输入新{typeList[changeType]}</div>
                </div>
                <div className={css.content}>
                    <div>
                        <Form className={`${css.changePhoneForm} clear`}>
                            <Form.Item>
                                {getFieldDecorator(changeType, {
                                    rules: changeType === 'phone' ? [{
                                        ...Decorators.phone(),
                                        message: '请输入11位的手机号码',
                                        required: false,
                                    }] : [{
                                        ...Decorators.email(),
                                        required: false,
                                    }],
                                    initialValue: ''
                                })(
                                    <Input
                                        placeholder={typeList[changeType]}
                                        prefix={this.getIcon}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                    <div className={css.footerBt}>
                        <Button onClick={this.nextStep} className={css.nextBt}>确认修改</Button>
                        <Button onClick={ModulesAction.closeChangContactM} className={css.cancelBt}>取消</Button>
                    </div>
                                
                </div>
            </div>
        );
    }
    /** 
     * 获取图标
     */
    private get getIcon() {
        const changeType = this.modulesState.changContactType;
        if (changeType === 'phone') {
            return <Icon
                className={css.inputIcon}
                color="#000"
                width={14}
                height={14}
                src={require('./img/img.phone.svg')}
            />;
        } 
        return <Icon
            className={css.inputEmailIcon}
            color="#000"
            width={20}
            height={20}
            src={require('./img/img.email.svg')}
        />;
    }
    /** 下一步 */
    private nextStep = () => {
        this.props.form.validateFields((err, val) => {
            if (!err) {
                ModulesAction.userEdit(val);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/UI.ContactM.tsx